// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1dTZs","info":"PatientInfo_info__3LgL2"};